module.exports = {
  "pageview": {
    "name": "pageview",
    "class": "view",
    "properties": {
      "screen": "string",
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "url": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "developer-docs",
    "version": "1"
  },
  "request-interaction": {
    "name": "request interaction",
    "class": "interaction",
    "properties": {
      "action": [
        "change language",
        "copy request"
      ],
      "language": {
        "type": "string"
      },
      "endpoint": {
        "type": "string"
      },
      "method": {
        "type": "string"
      }
    },
    "namespace": "developer-docs",
    "version": "1"
  },
  "param-form-interaction": {
    "name": "param form interaction",
    "class": "interaction",
    "properties": {
      "action": [
        "modify field value"
      ],
      "paramType": {
        "type": "string"
      }
    },
    "namespace": "developer-docs",
    "version": "1"
  },
  "test-call": {
    "name": "test call",
    "class": "usage",
    "properties": {
      "action": [
        "make test call"
      ],
      "authType": {
        "type": [
          "developer_hapikey",
          "oauth",
          "noauth"
        ]
      },
      "endpoint": {
        "type": "string"
      },
      "method": {
        "type": "string"
      },
      "status": {
        "type": "number"
      },
      "demo": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "developer-docs",
    "version": "1"
  },
  "help-link-interaction": {
    "name": "help link interaction",
    "class": "interaction",
    "properties": {
      "action": [
        "clicked API key account settings link",
        "clicked developer API key docs link",
        "clicked OAuth learn more link",
        "clicked Private apps learn more link"
      ]
    },
    "namespace": "developer-docs",
    "version": "1"
  }
};